module.exports = __webpack_public_path__ + "static/media/triangle.19af0a76.svg";